import { createUseStyles } from "react-jss";
import colors from "../constants/colors";

const styles = createUseStyles({
  svgIcon: {
    // flex: 0,
    marginRight: "0.5rem",
    marginLeft: "1rem",
  },
  inputContainer: {
    flex: 1,
    flexDirection: "row",
    borderRadius: "0.375rem",
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: colors.input.border,
    backgroundColor: colors.white,
    width: "100%",
  },
  input: {
    display: "flex",
    flex: 1,
    backgroundColor: colors.white,
    border: 0,
    outline: 0,
    color: colors.black,
    fontFamily: "'Poppins', sans-serif",
    fontSize: "1rem",
    fontWeight: 400,
    "-webkit-appearance": "none",
    width: "100%",
  },
});

export default styles;
